import {cDateField}     from "../../components/date-field/date-field";
import {cUtil}          from "../../functions/util";
import {cOrderListItem} from "../../components/order-list-item/order-list-item";

export class cOrderList implements OrderItemContainer, DateFieldTop {

  div_titleArea        = document.querySelector('.c-page-header div:nth-child(2)') as HTMLElement;
  h1_title             = document.createElement('h1');
  button_rename        = document.createElement('button');
  input_rename         = document.createElement('input');
  button_renameSave    = document.createElement('button');
  button_addToCart     = document.createElement('button');

  div_infoArea         = document.createElement('div');
  p_productsLabel      = document.createElement('p');
  p_productsCount      = document.createElement('p');

  p_priceLabel         = document.createElement('p');
  p_price              = document.createElement('p');
  button_menu          = document.createElement('button');
  div_menu             = document.createElement('div');
  button_duplicate     = document.createElement('button');
  button_delete        = document.createElement('button');
  button_save          = document.createElement('button');
  button_add           = document.createElement('button');

  fieldset_duplicate   = document.createElement('fieldset');
  label_duplicateName  = document.createElement('label');
  input_duplicateName  = document.createElement('input');
  label_customer       = document.createElement('label');
  select_customer      = document.createElement('select');
  button_duplicateSave = document.createElement('button');

  fieldset_addProducts = document.createElement('fieldset');
  label_addProducts    = document.createElement('label');
  textarea_addProducts = document.createElement('textarea');
  button_addProducts   = document.createElement('button');
  div_messagesErrors   = document.createElement('div');
  div_spinner          = document.createElement('div');
  span_spinner         = document.createElement('span');
  parent               = document.createElement('div');
  container            = document.querySelector('.c-order-list') as HTMLFormElement;
  script               = document.querySelector('.c-order-list script') as HTMLScriptElement;
  body                 = document.querySelector('body') as HTMLElement;

  fromDate           : cDateField;
  toDate             : cDateField;
  commonDeliveryDate : cDateField;
  input              : OrderListData;
  items              : cOrderListItem[] = [];
  oldCustomerId      : string;
  errors             : Set<{msg: string, type: 'alert'|'warning'|'info'|'success'}>;


  static dataExists(): boolean {
    const script = document.querySelector('.c-order-list script');
    return script !== null;
  }

  constructor() {
    const { __, _x, _n, sprintf } = wp.i18n as i18n;

    this.errors        = new Set();
    this.input         = JSON.parse(this.script.textContent);
    this.oldCustomerId = this.input.list.customer_id;

    for (const item of this.input.listItems) {
      if (['special-price', 'new', 'offer'].includes(this.input.list.tag)) {
        item.isDeletable = false;
      }
      if (!this.input.isAdmin && this.input.list.tag !== '') {
        item.isDeletable = false;
      }
      // Offer lists preselect the first delivery date of the sale
      const salePrice = item.product.amounts.prices.find(p => p.isOnSale);
      if (this.input.list.tag === 'offer' && salePrice && item.item.delivery_date === '') {
        item.item.delivery_date = item.product.deliveryDates.validDates.find(d => d >= salePrice.fromDate) ?? '';
      }
    }

    this.input.listItems.sort((a, b) => {
      const catA  = a.product.priceListCode
      const catB  = b.product.priceListCode
      const nameA = a.product.name.toLowerCase();
      const nameB = b.product.name.toLowerCase();
      const strA  = catA + nameA;
      const strB  = catB + nameB;
      return strA.localeCompare(strB);
    });

    // ---- Group items by sale date ----
    const saleGroups = new Map<string, OrderListItemData[]>();

    for (const item of this.input.listItems) {
      const salePrice = item.product.amounts.prices.find(p => p.isOnSale);
      let key = 
        salePrice 
        ? `${salePrice.fromDate}:${salePrice.toDate}` 
        : 'noSale';

      if (this.input.list.tag !== 'offer') key = 'noSale';

      if (!saleGroups.has(key)) saleGroups.set(key, []);
      saleGroups.get(key)!.push(item);
    }
    const sortedSaleKeys = 
      Array.from(saleGroups.keys())
      .sort((a, b) => a.localeCompare(b));


    // ---- Structure ----

    this.div_titleArea.append(this.h1_title);
    this.div_titleArea.append(this.input_rename);
    this.div_titleArea.append(this.button_rename);
    this.div_titleArea.append(this.button_renameSave);
    this.div_titleArea.append(this.button_addToCart);

    this.parent.append(this.div_infoArea);

    this.fromDate = new cDateField({
      validDates   : [],
      initDate     : this.input.list.valid_from,
      label        : __('Gültig ab', 'custom'),
      placeholder  : __('Gültig ab', 'custom'),
      parentElm    : this.div_infoArea,
      parentObj    : this,
      eventDefault : '',
      cssClass     : 'c-from-date',
      emptyAllowed : true,
    });

    this.toDate = new cDateField({
      validDates   : [],
      initDate     : this.input.list.valid_to,
      label        : __('Gültig bis', 'custom'),
      placeholder  : __('Gültig bis', 'custom'),
      parentElm    : this.div_infoArea,
      parentObj    : this,
      eventDefault : '',
      cssClass     : 'c-to-date',
      emptyAllowed : true,
    });

    this.div_infoArea.append(this.p_productsLabel);
    this.div_infoArea.append(this.p_productsCount);

    const deliveryDateLabel =
      cUtil.customerPickUp()
        ? __('Abholung', 'custom')
        : __('Lieferung', 'custom');

    this.commonDeliveryDate = new cDateField({
      validDates   : ['1970-01-01'],
      initDate     : '',
      label        : deliveryDateLabel + ':',
      placeholder  : __('Datum', 'custom'),
      parentElm    : this.div_infoArea,
      parentObj    : this,
      eventDefault : 'commonDeliveryDate',
      cssClass     : 'c-common-delivery-date',
      emptyAllowed : true,
    });


    this.div_infoArea.append(this.p_priceLabel);
    this.div_infoArea.append(this.p_price);
    this.div_infoArea.append(this.button_menu);
    this.div_infoArea.append(this.div_menu);
      this.div_menu.append(this.button_duplicate);
      this.div_menu.append(this.button_delete);
      this.div_menu.append(this.button_save);
      this.div_menu.append(this.button_add);

    this.div_infoArea.append(this.div_spinner);
      this.div_spinner.append(this.span_spinner);

    this.parent.append(this.fieldset_duplicate);
      this.fieldset_duplicate.append(this.label_duplicateName);
      this.fieldset_duplicate.append(this.input_duplicateName);
      this.fieldset_duplicate.append(this.label_customer);
      this.fieldset_duplicate.append(this.select_customer);
      this.fieldset_duplicate.append(this.button_duplicateSave);

    this.parent.append(this.fieldset_addProducts);
      this.fieldset_addProducts.append(this.label_addProducts);
      this.fieldset_addProducts.append(this.textarea_addProducts);
      this.fieldset_addProducts.append(this.button_addProducts);

    this.parent.append(this.div_messagesErrors);

    if (this.input.customers.length !== 0) {

      for (const customer of this.input.customers) {
        const option     = document.createElement('option');
        option.value     = customer.customerId;
        option.textContent = customer.customerName;
        option.selected  = customer.customerId === this.input.list.customer_id;
        this.select_customer.append(option);
      }
    }

    for (const saleDates of sortedSaleKeys) {

      const groupItems = saleGroups.get(saleDates)!;
      const div_group  = document.createElement('div');
      this.parent.append(div_group);
      div_group .classList.add('c-sale-group');

      if (saleDates !== 'noSale') {
        const formattedDates = 
        saleDates.split(':')
        .map(item => item.split('-').reverse().join('.'))
        .join(` ${__('bis')} `);
    
        const h2_group = document.createElement('h2');
        div_group.append(h2_group);
        h2_group.textContent = `${__('Aktionen vom', 'custom')} ${formattedDates}`;
        h2_group.classList.add('c-sale-group-heading');
      }

      for (const item of groupItems) {
        this.items.push(new cOrderListItem(
          item,
          div_group,
          this.input.nonce,
          this,
          'order-list'
        ));
      }
    }


    // Die Datumsfelder im Kopf vor den Artikeln, wie im Warenkorb. Auch Enter folgt dieser Reihenfolge.
    this.fromDate          .setTabIndex(1);
    this.toDate            .setTabIndex(2);
    this.commonDeliveryDate.setTabIndex(3);
    this.items.forEach((item, index) => item.setTabIndex((index + 1) * 100));

    // ---- Texts ----
    this.input_rename         .setAttribute('aria-label', __('Name', 'custom'));
    this.button_rename        .setAttribute('aria-label', __('Liste umbenenen', 'custom'));
    this.button_renameSave    .textContent = __('Name speichern', 'custom');
    this.button_addToCart     .textContent = __('Zum Warenkorb hinzufügen', 'custom');
    this.label_duplicateName  .textContent = __('Neuer Name', 'custom');
    this.label_customer       .textContent = __('Zu Kunde kopieren', 'custom');
    this.button_duplicateSave .textContent = __('Liste kopieren', 'custom');
    this.p_productsLabel      .textContent = __('Produkte', 'custom') + ':';
    this.p_priceLabel         .textContent = __('Totale Lieferung', 'custom') + ':';
    this.button_duplicate     .textContent = __('Liste kopieren', 'custom');
    this.button_delete        .textContent = __('Liste löschen', 'custom');
    this.button_save          .textContent = __('Liste speichern', 'custom');
    this.label_addProducts    .textContent = __('Artikel Hinzufügen', 'custom');
    this.button_add           .textContent = __('Artikel Hinzufügen', 'custom');
    this.button_addProducts   .textContent = __('Artikel Hinzufügen', 'custom');
    this.textarea_addProducts .placeholder = __('Geben Sie eine Liste von Artikelnummern ein. Es fuktionieren auch Kopien aus Excel, Word, PDF, etc.', 'custom');

    // ---- Classes ----
    this.button_renameSave.classList .add('c-button-simple');
    this.button_addToCart.classList  .add('c-button-simple');
    this.button_duplicateSave        .classList.add('c-button-simple');
    this.button_addProducts          .classList.add('c-button-simple');
    this.button_rename               .classList.add('c-button-icon');
    this.button_menu                 .classList.add('c-button-icon');

    this.fieldset_duplicate   .classList.add('fieldset_duplicate');
    this.label_duplicateName  .classList.add('label_duplicateName');
    this.input_duplicateName  .classList.add('input_duplicateName');
    this.label_customer       .classList.add('label_customer');
    this.select_customer      .classList.add('select_customer');
    this.button_duplicateSave .classList.add('button_duplicateSave');
    this.fieldset_addProducts .classList.add('fieldset_addProducts');
    this.label_addProducts    .classList.add('label_addProducts');
    this.textarea_addProducts .classList.add('textarea_addProducts');
    this.button_addProducts   .classList.add('button_addProducts');
    this.p_productsLabel      .classList.add('p_productsLabel');
    this.p_productsCount      .classList.add('p_productsCount');
    this.p_priceLabel         .classList.add('p_priceLabel');
    this.p_price              .classList.add('p_price');
    this.button_menu          .classList.add('button_menu');
    this.div_menu             .classList.add('div_menu');
    this.div_infoArea         .classList.add('div_infoArea');
    this.div_messagesErrors   .classList.add('c-cart-messages', 'div_messagesErrors');

    // ---- Label Ids ----
    cUtil.labelIds(this.label_duplicateName, this.input_duplicateName);
    cUtil.labelIds(this.label_customer,      this.select_customer);
    cUtil.labelIds(this.label_addProducts,   this.textarea_addProducts);

    // ---- Other ----
    this.input_rename.type         = 'text';
    this.input_duplicateName.type  = 'text';
    this.button_renameSave.type    = 'button';
    this.button_duplicateSave.type = 'button';
    this.button_duplicate.type     = 'button';
    this.button_rename.type        = 'button';
    this.button_delete.type        = 'button';
    this.button_save.type          = 'button';
    this.button_addToCart.type     = 'button';
    this.button_menu.type          = 'button';
    this.button_addProducts.type   = 'button';
    this.button_add.type           = 'button';

    // ---- init ----
    this.input_rename         .classList.add('c-hidden');
    this.button_renameSave    .classList.add('c-hidden');
    this.fieldset_duplicate   .classList.add('c-hidden');
    this.fieldset_addProducts .classList.add('c-hidden');
    this.div_menu             .classList.add('c-hidden');

    if (['special-price', 'new', 'offer'].includes(this.input.list.tag)) {
      this.fromDate.fieldset .classList.add('c-hidden');
      this.toDate.fieldset   .classList.add('c-hidden');
      this.button_rename     .classList.add('c-hidden');
      this.button_delete     .classList.add('c-hidden');
      this.button_add        .classList.add('c-hidden');
    }
    if (!this.input.isAdmin && this.input.list.tag !== '') {
      this.button_rename.classList.add('c-hidden');
      this.button_delete.classList.add('c-hidden');
    }
    if (!this.input.isAdmin) {
      this.fromDate.fieldset .classList.add('c-hidden');
      this.toDate.fieldset   .classList.add('c-hidden');
      this.button_add        .classList.add('c-hidden');
    }
    // Without a customer account: view and add to cart only, nothing is saved
    if (this.input.readOnly) {
      this.button_rename.classList.add('c-hidden');
      this.button_menu  .classList.add('c-hidden');
    }

    this.h1_title.textContent        = this.input.list.name;
    this.input_duplicateName.value = this.input.list.name;
    this.input_rename.value        = this.input.list.name;

    this.changeEvent('cOrderList init');

    this.container.append(this.parent);

    // ---- Events ----
    cUtil.enterToNextField(this.container);

    // Menu
    this.button_menu.addEventListener('click', (e) => {
      this.div_menu.classList.toggle('c-hidden');
      e.stopPropagation();
    });

    this.button_rename.addEventListener('click', (e) => {
      e.stopPropagation();
      this.openRename();
      this.closeMenu();
    });

    this.button_duplicate.addEventListener('click', (e) => {
      e.stopPropagation();
      this.openDuplicate();
      this.closeMenu();
    });

    this.button_add.addEventListener('click', (e) => {
      e.stopPropagation();
      this.openAddProducts();
      this.closeMenu();
    });

    this.button_delete.addEventListener('click', async () => {
      const list = this.getListData();
      const data = JSON.stringify(list);
      this.div_spinner.classList.add('c-spinner-list');
      const error = await this.fetch(data, 'c_order_list_delete');

      if (error === 'ok') {
        const message = __('Die Liste wurde gelöscht.', 'custom');
        this.addError(message, 'success');
        this.displayErrors();
        window.location.replace(cUtil.url('/bestelllisten/'));
        return;
      }
      else {
        this.div_spinner.classList.remove('c-spinner-list');
        this.addError(error, 'alert');
        this.displayErrors();
        this.closeMenu();
      }
    });

    this.button_renameSave.addEventListener('click', async (e) => {
      e.stopPropagation();

      const list = this.getListData();
      const data = JSON.stringify(list);
      this.div_spinner.classList.add('c-spinner-list');
      const error = await this.fetch(data, 'c_order_list_rename');
      this.div_spinner.classList.remove('c-spinner-list');

      if (error === 'ok') {
        let message = __('Die Liste wurde gespeichert', 'custom',);
        this.addError(message, 'success');
        this.displayErrors();
      }
      else {
        this.addError(error, 'alert');
        this.displayErrors();
        return;
      }

      this.h1_title.textContent = this.input_rename.value;
      this.closeRename();
    });

    this.input_rename.addEventListener('click', (e) => {
      e.stopPropagation();
    });

    this.fieldset_duplicate.addEventListener('click', (e) => {
      e.stopPropagation();
    });
    this.fieldset_addProducts.addEventListener('click', (e) => {
      e.stopPropagation();
    });

    this.button_duplicateSave.addEventListener('click', async () => {

      const dataObj: OrderListReturnData = {
        oldCustomerId: this.oldCustomerId,
        orderList: this.getListDataDuplicate(),
        orderListItems: this.getItemData()
      };
      const data = JSON.stringify(dataObj);
      this.div_spinner.classList.add('c-spinner-list');
      const result = await this.fetch(data, 'c_order_list_duplicate') as string;

      if (result === 'error-auth') {
        this.div_spinner.classList.remove('c-spinner-list');
        let message = __('Nicht Autorisiert', 'custom',);
        this.addError(message, 'alert');
        this.displayErrors();
        return;
      }
      else if (result === 'error-format') {
        this.div_spinner.classList.remove('c-spinner-list');
        let message = __('Ungültiges Datenformat', 'custom',);
        this.addError(message, 'alert');
        this.displayErrors();
        return;
      }
      else if (result === 'error-customer') {
        this.div_spinner.classList.remove('c-spinner-list');
        let message = __('Ungültiger Kunde', 'custom',);
        this.addError(message, 'alert');
        this.displayErrors();
        return;
      }

      if (this.oldCustomerId === dataObj.orderList.customer_id) {
        this.h1_title.textContent = this.input_rename.value;
        window.location.href = cUtil.url(`/bestelllisten/${result}`);
      }
      else {
        this.div_spinner.classList.remove('c-spinner-list');
        let message = __('Die Kopie wurde erstellet. Bitte wechseln Sie zur Bestelllistenübersicht im entsprechenden Kundenkonto.', 'custom',);
        this.addError(message, 'success');
        this.displayErrors();
        this.closeDuplicate();
        return;
      }
    });

    this.button_addProducts.addEventListener('click', async () => {
      const newProducts = this.getProductsList();
      const data = JSON.stringify(newProducts);
      this.div_spinner.classList.add('c-spinner-list');
      const result = await this.fetch(data, 'c_order_list_add_products') as string;

      if (result === 'error-auth') {
        this.div_spinner.classList.remove('c-spinner-list');
        let message = __('Nicht Autorisiert', 'custom',);
        this.addError(message, 'alert');
        this.displayErrors();
        return;
      }
      else if (result === 'error-format') {
        this.div_spinner.classList.remove('c-spinner-list');
        let message = __('Ungültiges Datenformat', 'custom',);
        this.addError(message, 'alert');
        this.displayErrors();
        return;
      }
      else {
        let message = __('Die Artikel wurden hinzugefügt.', 'custom',);
        this.addError(message, 'success');
        this.displayErrors();
        this.closeDuplicate();
        window.location.reload();
        return;
      }
    });

    this.body.addEventListener('click', (e) => {
      this.div_menu.classList.add('c-hidden');
      this.closeDuplicate();
      this.closeRename();
      this.closeAddProducts();
    });

    this.button_save.addEventListener('click', async () => {

      const dataObj: OrderListReturnData = {
        oldCustomerId: this.oldCustomerId,
        orderList: this.getListData(),
        orderListItems: this.getItemData()
      };

      const data = JSON.stringify(dataObj);
      this.div_spinner.classList.add('c-spinner-list');
      const error = await this.fetch(data, 'c_order_list_save');

      if (error === 'ok') {
        this.div_spinner.classList.remove('c-spinner-list');
        let message = __('Die Liste wurde gespeichert.', 'custom');
        this.addError(message, 'success');
        this.displayErrors();
      }
      else if (error === 'ok-mass') {
        let message = __('Die Listen wurden gespeichert. Sie werden jetzt auf die Listenübersicht weitergeleitet.', 'custom');
        this.addError(message, 'success');
        this.displayErrors();
        window.location.replace(cUtil.url('/bestelllisten/'));
      }
      else {
        this.div_spinner.classList.remove('c-spinner-list');
        this.addError(error, 'alert');
        this.displayErrors();
      }
    });

    this.button_addToCart.addEventListener('click', async () => {

      if (!this.validateItems()) return;

      const dataObj: OrderListReturnData = {
        oldCustomerId: this.oldCustomerId,
        orderList: this.getListData(),
        orderListItems: this.getItemDataSelected()
      };
      const data = JSON.stringify(dataObj);
      this.div_spinner.classList.add('c-spinner-list');
      const error = await this.fetch(data, 'c_order_list_add_to_cart');

      if (error !== 'ok') {
        this.div_spinner.classList.remove('c-spinner-list');
        this.addError(error, 'alert');
        this.displayErrors();
        return;
      }
      const productItems =
        this.items
          .map(item => item.productItem)
          .filter(item => {
            const amounts = item.amounts.calculateAmounts();
            return amounts.totalAmount !== 0;
          });
      cUtil.gaSaveData(productItems, 'add_to_cart', 'order-list', this.input.list.name);
      window.location.href = cUtil.url('/warenkorb/');
    });
  }
  // ---------------- Public ----------------
  changeEvent(eventSource: string): void {
    if (eventSource === 'cOrderList init') {
      this.commonDeliveryDate.setValidDates(this.getCommonValidDates());
      this.initCommonDate();
      this.validateItems();
      this.updateTotalAmount();
    }
    if (eventSource === 'commonDeliveryDate') {
      const date = this.commonDeliveryDate.getDate();
      this.items.forEach(item => item.setDeliveryDate(date));
      this.validateItems();
      this.updateTotalAmount();
    }
    if (eventSource === 'cProductItemDeliveryDate_constructor_dateFieldDefault') {
      this.clearCommonDateIfDiffers();
      this.validateItems();
      this.updateTotalAmount();
    }
    if (eventSource === 'cProductItemAmounts_change') {
      this.commonDeliveryDate.setValidDates(this.getCommonValidDates());
      this.validateItems();
      this.updateTotalAmount();
    }
    if (eventSource === 'cProductItemMarinades_change') {
      this.commonDeliveryDate.setValidDates(this.getCommonValidDates());
      this.validateItems();
      this.updateTotalAmount();
    }
    if (eventSource === 'cOrderListItem selected') {
      this.commonDeliveryDate.setValidDates(this.getCommonValidDates());
      this.validateItems();
      this.updateTotalAmount();
    }
  }

  validateItem(silent: 'silent'|'', message: 'list'|'', isSelected?: boolean): boolean {
    return true;
  }

  deleteItem(itemId: string) {
    const { __, _x, _n, sprintf } = wp.i18n as i18n;
    this.items =
      this.items
      .filter(item => item.inputData.item.item_id !== itemId);

    const message = __('Das Element wurde gelöscht', 'custom');

    this.addError(message, 'success');
    this.displayErrors();
    this.validateItems();
  }

  setErrorMessage(message: string) {
    this.addError(message, 'alert');
    this.displayErrors();
  }

  // ---------------- Private Methods ----------------
  private openRename() {
    this.h1_title.classList.add('c-hidden');
    this.button_rename.classList.add('c-hidden');
    this.input_rename.classList.remove('c-hidden');
    this.button_renameSave.classList.remove('c-hidden');
  }
  private closeRename() {
    this.h1_title.classList.remove('c-hidden');
    this.button_rename.classList.remove('c-hidden');
    this.input_rename.classList.add('c-hidden');
    this.button_renameSave.classList.add('c-hidden');

    if (!this.canRename()) {
      this.button_rename.classList.add('c-hidden');
    }
  }
  private canRename(): boolean {
    if (this.input.readOnly) return false;
    if (['special-price', 'new', 'offer'].includes(this.input.list.tag)) return false;
    if (!this.input.isAdmin && this.input.list.tag !== '') return false;
    return true;
  }
  private openDuplicate() {
    this.fieldset_duplicate.classList.remove('c-hidden');
  }
  private closeDuplicate() {
    this.fieldset_duplicate.classList.add('c-hidden');
  }
  private openAddProducts() {
    this.fieldset_addProducts.classList.remove('c-hidden');
  }
  private closeAddProducts() {
    this.fieldset_addProducts.classList.add('c-hidden');
  }
  private closeMenu() {
    this.div_menu.classList.add('c-hidden');
  }

  private getListData(): OrderList {
    const list: OrderList = {
      customer_id: this.input.list.customer_id,
      list_id: this.input.list.list_id,
      name: this.input_rename.value,
      delivery_date: this.getDate(),
      tag: this.input.list.tag,
      valid_from: this.fromDate.getDate(),
      valid_to: this.toDate.getDate(),
    }
    return list;
  }

  private getListDataDuplicate(): OrderList {
    const list = this.getListData();
    list.customer_id = this.select_customer.value;
    list.name = this.input_duplicateName.value;
    return list;
  }

  // The header date is only ever what the user chose, never derived from the item dates.
  // A saved one is shown and applied to the items like a choice in the header, unless it has passed.
  private initCommonDate() {
    const date = this.input.list.delivery_date;
    if (date === '' || date < cUtil.currentIsoDateCET()) return;

    this.commonDeliveryDate.setDate(date);
    this.items.forEach(item => item.setDeliveryDate(date));
  }

  // An item date was changed by hand: a header date that no longer applies to all items is cleared
  private clearCommonDateIfDiffers() {
    const date = this.commonDeliveryDate.getDate();
    if (date === '') return;

    const differs = this.items.some(item => item.getDeliveryDate() !== date);
    if (differs) this.commonDeliveryDate.setDate('');
  }

  private getCommonValidDates(): string[] {

    const dateArrays =
      this.items
      .map(item => item.inputData.product.deliveryDates.validDates);

    const dateSets =
      dateArrays.map((arr) => new Set(arr));

    const [smallestSet, ...otherSets] = dateSets.sort((a, b) => a.size - b.size);
    if (smallestSet === undefined) return [];
    
    const smallest = Array.from(smallestSet.values())
    return smallest.filter(val => otherSets.every(set => set.has(val)));
  }

  private getItemData(): OrderListItem[] {
    return this.items
      .map(item => {
        const orderListItem = item.productItem.getData();
        orderListItem.list_id = this.input.list.list_id;
        orderListItem.customer_id = this.select_customer.value;
        return orderListItem;
      });
  }

  private getItemDataSelected(): OrderListItem[] {
    return this.items
      .filter(item => item.isSelectedAndNotEmpty())
      .map(item => {
        const orderListItem = item.productItem.getData();
        orderListItem.list_id = this.input.list.list_id;
        orderListItem.customer_id = this.select_customer.value;
        return orderListItem;
      });
  }

  private getProductsList(): OrderListAddProducts {
    const data = this.textarea_addProducts.value;
    const numbers = data.match(/\d+/g) || [];
    const newProducts = {
      productIds: numbers.join(','),
      customerId: this.oldCustomerId,
      listId: this.input.list.list_id,
    } as OrderListAddProducts;
    return newProducts;
  }

  private getDate(): string {
    return this.commonDeliveryDate.getDate();
  }

  private validateItems(): boolean {
    const { __, _x, _n, sprintf } = wp.i18n as i18n;

    this.clearErrors();

    const isValidDel =
      this.items
      .filter(item => item.inputData.item.sku === 'none')
      .length === 0;

    if (!isValidDel) {
      const messageDel = __('Die Liste enthält gelöschte Produkte', 'custom');
      this.addError(messageDel, 'warning');
    }

    const isValidCommonDeliveryDate = this.validateCommonDeliveryDate();

    const isValidItems =
      this.items
      .map(item => item.validateItem('', ''))
      .filter(item => item === false)
      .length === 0;

    if (!isValidItems || !isValidCommonDeliveryDate) {
      const messageItem = __('Diese Liste enthält fehlerhafte Eingaben.', 'custom');
      this.addError(messageItem, 'alert');
    }

    const isValidFrom = this.fromDate.validateItem('', 'list');
    const isValidTo   = this.toDate.validateItem('', 'list');
    const isEmptyFrom = this.fromDate.getDate() === '';
    const isMassList  = this.input.list.tag !== '' && !['special-price', 'new', 'offer'].includes(this.input.list.tag);

    let isValidFromTo = isValidFrom && isValidTo;
    if (isMassList && isEmptyFrom) {
      isValidFromTo = false;
      const messageItem = __('Massenlisten können kein leeres Von-Datum haben.', 'custom');
      this.addError(messageItem, 'alert');
    }

    if (!isValidDel || !isValidCommonDeliveryDate || !isValidItems || !isValidFromTo) {
      this.displayErrors();
      return false;
    }

    this.displayErrors();
    return true;
  }

  private validateCommonDeliveryDate() {
    const commonDates = this.getCommonValidDates();
    const isEmptyList = commonDates.length === 0;

    if (isEmptyList) {
      this.commonDeliveryDate.removeError();
      return true;
    }

    const isValid = this.commonDeliveryDate.validateItem('', 'list');

    return isValid;
  }

  private updateTotalAmount() {
    const items =
      this.items
        .filter(item => item.isSelectedAndNotEmpty());

    const totalValue =
      items
        .map(item => item.productItem.amounts.getAmounts())
        .reduce((sum, item) => sum + item, 0)
        .toFixed(2);

    this.p_productsCount.textContent = String(items.length);
    this.p_price.textContent = `CHF ${totalValue}`;
  }

  private async fetch(data: string, action: string): Promise<string> {
    const formData = new FormData();
    formData.append('_ajax_nonce', this.input.nonce);
    formData.append('action', action);
    formData.append('data', data);

    const response = await fetch('/wp-admin/admin-ajax.php', {
      method: 'POST',
      body: formData
    });
    const responseData = await response.json() as string;
    return responseData;
  }

  private arrayIntersect(arr1: string[], arr2: string[]) {
    return arr1.filter(element => arr2.includes(element));
  }

  private message(text: string, element: HTMLElement, type: 'alert' | 'warning' | 'info' | 'success') {
    element.classList.remove('c-alert');
    element.classList.remove('c-warning');
    element.classList.remove('c-info');
    element.classList.remove('c-success');

    element.textContent = text;

    if (text === '') return;

    const typeClass =
      type === 'alert'   ? 'c-alert'   :
      type === 'warning' ? 'c-warning' :
      type === 'info'    ? 'c-info'    :
      type === 'success' ? 'c-success' :
      'c-info';

    element.classList.add(typeClass);
  }
  private addError(text: string, type: 'alert'|'warning'|'info'|'success') {
    this.errors.add({msg: text, type: type});
  }
  private clearErrors() {
    this.errors.clear();
  }
  private displayErrors() {
    this.div_messagesErrors.replaceChildren();
    for(let error of this.errors) {
      const p_error = document.createElement('p');
      p_error.textContent = error.msg;

      const typeClass =
        error.type === 'alert'   ? 'c-alert'   :
        error.type === 'warning' ? 'c-warning' :
        error.type === 'info'    ? 'c-info'    :
        error.type === 'success' ? 'c-success' :
        /*else*/                   'c-info'    ;
      
      p_error.classList.add(typeClass, 'c-cart-messages');

      this.div_messagesErrors.append(p_error);
    }
  }
}
